import HighchartsReact from "highcharts-react-official";
import Highcharts from 'highcharts';
import { useIssueTypeSummary } from "../../Hooks/Features/ProjectDashboard/useIssueTypeSummary"
import { SkeletonContainer } from "../Loader/Loader";

const IssueTypeSummary = () => {
    const { options, loader, noData } = useIssueTypeSummary();
    return (
        <div className="w100" style={{ height: "100%" }} title="Issue type Summary">
            <div className="card-container">
                <div style={{ height: "100%" }}>
                    {
                        loader ? <div style={{ height: "inherit" }}>
                            <SkeletonContainer />
                        </div> :
                            noData ? <div className="w100 d-flex justify-content-center align-items-center" style={{ height: "inherit" }}>
                                <div className='text-center'>
                                    <img src={"./assets/nodata.jpg"} alt='no data' />
                                    <p className=' red mt-3'> Data Not Found</p>
                                </div>
                            </div> :
                                <HighchartsReact highcharts={Highcharts} options={options} containerProps={{
                                    style: {
                                        height: "inherit",
                                    },
                                }} />
                    }
                </div>
            </div>
        </div >
    )
}

export default IssueTypeSummary